import { useState } from 'react';
import { ajaxRequest } from '../../utils/helpers';
import { showError } from '../../globalMessages/globalMessagesClient';

const { exchangeUrl } = window.inlineGlobalConfig;

export const useExchangeLogin = ({ setExchangeData }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const exchangeLoginRequest = ({ orderCode, email }) => {
    setLoading(true);
    ajaxRequest('POST', exchangeUrl, { orderCode, email: email.toLowerCase() })
      .then(res => {
        if (res.status === 'error') {
          setError(res.message);
          showError({
            message: res.message,
            autoHide: true,
            displayTime: 10,
            sticky: true,
          });
        }
        if (res.status === 'success') {
          setExchangeData(res);
          window.inlineExchange = { exchangeRequest: res };
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { exchangeLoginRequest, error, loading };
};
